import { FormControl, FormHelperText, TextField } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { Field } from "features/admin/Products/types";
import { useStyles } from "./styles";
import { Controller, useWatch } from "react-hook-form";
import { toBGN, toEuroNumber } from "features/utils";

interface NumberInputFieldProps {
  item: Field;
  control: any;
  reset: boolean;
  setValue: any;
  numberRef?: React.MutableRefObject<string>;
  errors?: any;
}

const NumberInputField: React.FC<NumberInputFieldProps> = ({ item, control, reset, setValue, numberRef, errors }) => {
  const classes = useStyles();
  const linkedBgnValue = useWatch({
    control,
    name: item.linkedTo || `__unlinked_${item.name}`,
    defaultValue: "",
  });

  useEffect(() => {
    setValue(item.name, item.value);
  }, [item.name, item.value, setValue]);

  useEffect(() => {
    if (!item.linkedTo) return;

    const euroValue =
      linkedBgnValue === "" || linkedBgnValue === null || linkedBgnValue === undefined
        ? ""
        : toEuroNumber(linkedBgnValue);
    setValue(item.name, euroValue);
  }, [item.linkedTo, item.name, linkedBgnValue, setValue]);

  const updateLinkedBgnValue = (euroValue: string) => {
    if (!item.linkedTo) return;

    setValue(
      item.linkedTo,
      euroValue === "" ? "" : toBGN(Number(euroValue))
    );
  };

  return (
    <FormControl required={item.required} className={classes.formControl}>
      <Controller
        defaultValue={item.value ?? ""}
        rules={item.rules}
        render={({ onChange, name, value }) => (
          <TextInputWrapper
            name={name}
            label={item.title}
            value={value}
            onChange={onChange}
            required={item.required}
            onValueChange={updateLinkedBgnValue}
            numberRef={numberRef}
            errors={errors}
          />
        )}
        name={item.name}
        control={control}
      />

      {item.required && <FormHelperText>Задължително</FormHelperText>}
    </FormControl>
  );
};

export default NumberInputField;

interface Props {
  value?: string | number;
  name: string;
  label: string;
  onChange: any;
  required: boolean;
  numberRef?: React.MutableRefObject<string>;
  errors?: any;
  onValueChange?: (value: string) => void;
}

const TextInputWrapper: React.FC<Props> = ({
  name,
  label,
  value,
  onChange,
  required,
  onValueChange,
  numberRef,
  errors,
}) => {
  const [text, setText] = useState(value ? value : "");
  useEffect(() => {
    setText(value ?? "");
  }, [value]);
  const handleChange = (event: any, onChange: any) => {
    setText(event.target.value);
    onChange(event.target.value);
    onValueChange && onValueChange(event.target.value);
    if (numberRef && numberRef.current !== undefined) {
      numberRef.current = event.target.value;
    }
  };
  const helperText = errors && errors[name] ? errors[name].message : "";
  const error = errors ? !!errors[name] : false;

  return (
    <TextField
      id={name}
      label={label}
      name={name}
      required={required}
      type="number"
      onChange={(e) => handleChange(e, onChange)}
      value={text}
      helperText={helperText}
      error={error}
      inputProps={{ step: "0.01" }}
      InputLabelProps={{
        shrink: true,
      }}
    />
  );
};
